import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Text } from '@/lib/v2/components';

type TextFiltersAppliedProps = {
  hasFiltersApplied: boolean;
  partial: number;
  moduleText: string;
};

const TextFiltersApplied = ({
  hasFiltersApplied = false,
  partial,
  moduleText,
}: TextFiltersAppliedProps) => {
  const { t } = useTranslation();
  if (!hasFiltersApplied)
    return <Text variant="text">{t('TextFiltersApplied.noFiltersMessage')}</Text>;
  return (
    <Text as="span" variant="text">
      <Trans
        components={{ comp: <Text as="span" color="primary" fontWeight="medium" variant="text" /> }}
        i18nKey={'TextFiltersApplied.hasFiltersMessage'}
        values={{ partial, moduleText }}
      />
    </Text>
  );
};

export default memo(TextFiltersApplied);
